<template>
  <div>
    <span
      v-for="(item, i) in items"
      :key="`${item.id}-${i}`"
      class="badge badge-pill badge-primary badge-semisquare light mr-1 text-truncate"
      :id="`item-${item.id}-${i}`"
    >
      {{ item.name }}
      <UeTooltip :target="`item-${item.id}-${i}`">{{ item.name }}</UeTooltip>
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'UePillList',
  props: {
    items: {
      type: Array as PropType<Array<Record<string, unknown>>>,
      required: true,
    },
  },
})
</script>

<style lang="sass" scoped>
.badge
  max-width: 120px
</style>
